export const cleanFtbParticipantId = (participantId?: string | null): string | null => {
  const normalizedParticipantId = participantId?.trim();

  if (!normalizedParticipantId) {
    return null;
  }

  return normalizedParticipantId.replace(/^.+_/, '');
};

export const buildFtbParticipantLogoUrl = (baseUrl?: string | null, participantId?: string | null): string | null => {
  const normalizedBaseUrl = baseUrl?.trim().replace(/\/+$/, '');
  const cleanId = cleanFtbParticipantId(participantId);

  if (!normalizedBaseUrl || !cleanId) {
    return null;
  }

  return `${normalizedBaseUrl}/${cleanId}.png`;
};
